var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alignText"},[_c('v-btn',{staticClass:"my-5",attrs:{"color":"primary"},on:{"click":_vm.redirectZohoForm}},[_vm._v(_vm._s(_vm.$t('publicPlayer.participate')))]),_c('p',{staticClass:"subText"},[_vm._v(_vm._s(_vm.$t('publicPlayer.info')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }